import { ActionSectionCombinedProps } from './types';

const usePresenter = (props: ActionSectionCombinedProps): ActionSectionCombinedProps => {
  return props;
};

export default usePresenter;
